<template>
  <div class="nav flex">
    <!-- 顶部左侧的菜单 -->
    <div class="tab-left flex">
      <div
        v-for="(item, index) of leftMenu"
        :key="index"
        class="nav-li"
        :class="[
          currentIndex === item.nameCode ? 'new-device-higlight' : 'new-device',
          item.nameCode === 'comunicate' ? 'new-comunicate' : '',
          item.nameCode,
          leftMenu.length === 5 ? 'ten-li' : '',
        ]"
        @click="clickEnter(item.nameCode)"
      >
        {{ item.name }}
        <div class="left-mune">
          <ul v-if="item.menus" class="nav-menu">
            <li
              v-for="child in item.menus"
              :key="child.key"
              v-has="child.vHas"
              :class="{ active: child.path === currentPath }"
              @click.stop="handleRouter(child.path, item.nameCode)"
            >
              {{ child.label }}
            </li>
          </ul>
        </div>
        <!-- 如果对讲菜单在左侧 -->
        <div class="popover popover-dark" v-if="showTip && item.nameCode === 'comunicate'">
          <span class="unread">{{ $t('unread') }}</span
          ><span class="check-view" @click.stop="toConver($t('VoiceMessage'))">{{ $t('check') }}！</span>
          <img @click.stop="closeTip" class="close" src="@/icon/ic_cancle.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 告警信息弹窗声音 -->
    <audio id="playAudio" muted="true" ref="audio" src="@/icon/audio/alarm.mp3"></audio>
    <!-- 顶部中间的系统名称 -->
    <div
      class="title"
      @click="clickEnter('home')"
      :class="
        systemName.length >= 16 && systemName.length <= 18
          ? 'eighteen'
          : systemName.length <= 15 && systemName.length >= 13
          ? 'fifteen'
          : systemName.length > 18
          ? 'twenty'
          : ''
      "
    >
      {{ systemName }}
    </div>
    <!-- 顶部右侧的菜单 -->
    <div class="tab-right flex">
      <div
        v-for="(item, index) of rightMenu"
        :key="index"
        class="nav-li"
        :class="[
          currentIndex === item.nameCode ? 'new-focus-higlight' : 'new-focus',
          item.nameCode === 'comunicate' ? 'new-comunicate' : '',
          item.nameCode,
          leftMenu.length === 5 ? 'ten-li' : '',
        ]"
        @click="clickEnter(item.nameCode, item)"
      >
        {{ item.name }}
        <div class="left-mune">
          <ul v-if="item.menus" class="nav-menu">
            <li
              v-for="child in item.menus"
              :key="child.key"
              v-has="child.vHas"
              :class="{ active: child.path === currentPath }"
              @click.stop="handleRouter(child.path, item.nameCode, child)"
            >
              {{ child.label }}
            </li>
          </ul>
        </div>
        <!-- 如果对讲菜单在右侧 -->
        <div class="popover popover-dark" v-if="showTip && item.nameCode === 'comunicate'">
          <span class="unread">{{ $t('unread') }}</span
          ><span class="check-view" @click.stop="toConver($t('VoiceMessage'))">{{ $t('check') }}！</span>
          <img @click.stop="closeTip" class="close" src="@/icon/ic_cancle.png" alt="" />
        </div>
      </div>
      <!-- 设置菜单 -->
      <div
        class="nav-li new-set"
        :class="[
          currentIndex === 'set' ? 'new-focus-higlight' : 'new-focus',
          setShowbyIcon ? 'menu-bg-none' : '',
          setShowbyIcon && rightMenu.length === 4 ? 'setting-margin' : '',
          rightMenu.length === 4 ? 'ten-li' : '',
        ]"
      >
        <img v-if="setShowbyIcon" src="@/icon/new-common/ic_setting.png" alt="" srcset="" @click="clickEnter('set')" />
        <div v-else @click="clickEnter('set')">{{ $t('setUp') }}</div>
        <div class="menu_list">
          <div class="nav-setting" :style="'width: ' + headerOffset.setMenuSize + 'px;'">
            <ul class="module-ul">
              <li
                class="module-li"
                v-for="item in menuList"
                :key="item.key"
                v-has="item.vHasParent != undefined ? item.vHasParent : item.vHas"
              >
                <div class="module-title" v-has="item.vHas">
                  <div class="title-boder"></div>
                  <span class="title-label">{{ item.label }}</span>
                </div>
                <ul class="nav-item-ul" v-has="item.vHas">
                  <li
                    class="nav-item-li"
                    v-for="(value, index) in item.navs"
                    :key="item.key + 'navs' + index"
                    :class="{ active: value.path === currentPath }"
                    @click="handleEnter(value.path)"
                    v-has="value.vHas"
                  >
                    <span v-if="value.IsHas === undefined || value.IsHas === true">{{ value.label }}</span>
                  </li>
                  <li class="nav-item-li" v-if="item.key === 'PersonalMessage' && checkFeatureCode('', false, true)">
                    <span @click="handleEnter('dmp')">{{ $t('digitalPlatform') }}</span>
                  </li>
                  <li class="nav-item-li" v-if="item.key === 'PersonalMessage'">
                    <span v-if="isDefaultTheme" @click="handleSwitchTheme('dark')">{{ $t('dark') }}</span>
                    <span v-else @click="handleSwitchTheme('default')">{{ $t('default') }}</span>
                  </li>
                  <div v-if="item.key === 'PersonalMessage'">
                    <li class="nav-item-li" 
                        v-for="(temp, i) in langs"
                    >
                    <span v-if="viewFont % 3 !== temp.value" @click="onSwitchLanguage(temp)">{{ $t(temp.label) }}</span>
                    </li>
                  </div>
                  <!-- <li class="nav-item-li" v-if="item.key === 'PersonalMessage'">
                    <span v-if="viewFont" @click="onSwitchLanguage('hk')">繁体中文</span>
                    <span v-if="!viewFont" @click="onSwitchLanguage('zh')">簡體中文</span>
                  </li> -->
                  <li class="nav-item-li" v-if="item.key === 'PersonalMessage'">
                    <span @click="handleEnter('logout')">{{ $t('signOut') }}</span>
                  </li>
                  <div style="height: 10px;" v-if="item.brothers"></div>
                </ul>
                <div class="module-title" v-if="item.brothers" v-has="item.brothers.vHas">
                  <div class="title-boder"></div>
                  <span class="title-label">{{ item.brothers.label }}</span>
                </div>
                <ul class="nav-item-ul" v-if="item.brothers" v-has="item.brothers.vHas">
                  <li
                    class="nav-item-li"
                    v-for="(value, index) in item.brothers.navs"
                    :key="item.key + 'navs-brothers' + index"
                    :class="{ active: value.path === currentPath }"
                    @click="handleEnter(value.path)"
                    v-has="value.vHas"
                  >
                    <span v-if="value.IsHas === undefined || value.IsHas === true">{{ value.label }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSession, delSession } from '@/api/common'
import themes from '@/util/themes'
import { closeRTC } from '@/common/rtc/index'
import { searchMenuCode, inlcudeDeviceSpecType } from '@/util/common'
import { tenantSysConfig } from '@/api/tenantSet'
import { mapGetters } from 'vuex'
import { switchMapType } from '@/common/map'
import { systemList } from '@/api/new-device/intSystem'
import { updateUserInfo } from '@/api/personal'
export default {
  data() {
    return {
      langs: [
        {
          value: 0,
          lang: 'zh',
          label: 'zh'
        },
        {
          value: 1,
          lang: 'hk',
          label: 'hk'
        },
        {
          value: 2,
          lang: 'en',
          label: 'en'
        }
      ],
      viewFont: 0,
      systemName: null,
      currentIndex: '',
      isShowMenu: false,
      currentPath: '',
      menuList: [
        {
          key: 'DataCenter',
          label: this.$t('DataRecord'),
          vHas: 'sys:new:setting:log',
          navs: [
            //考勤记录
            {
              path: 'AttRecord',
              label: this.$t('personAttRecord'),
              vHas: 'sys:new:setting:log:workRecord',
            },
            {
              label: this.$t('AlarmInforecord'),
              path: 'caution',
              vHas: 'sys:new:setting:log:alert',
            },
            {
              label: this.$t('DataFlowrecord'),
              path: 'mobileData',
              vHas: 'sys:new:setting:log:mobileData',
            },
            {
              label: this.$t('BatteryPowerrecord'),
              path: 'battery',
              vHas: 'sys:new:setting:log:battery',
            },
            {
              label: this.$t('MediaUploadrecord'),
              path: 'mediaUpload',
              vHas: 'sys:new:setting:log:media',
            },
            {
              label: this.$t('ModuleOperationrecord'),
              path: 'modules',
              vHas: 'sys:new:setting:log:module',
            },
            {
              label: this.$t('BackgroundOperationrecord'),
              path: 'operation',
              vHas: 'sys:new:setting:log:operation',
            },
            {
              label: this.$t('ElectronicFencerecord'),
              path: 'geoFence',
              vHas: 'sys:new:setting:log:geoFence',
            },
            {
              label: this.$t('OneClickHelprecord'),
              path: 'sos',
              vHas: 'sys:new:setting:log:emergencyHelp',
            },
            {
              label: this.$t('SystemStatistics'),
              path: 'statistics',
              vHas: 'sys:new:setting:log:static',
            },
            {
              path: 'Voiceprint',
              label: this.$t('SpeechRecognitionrecord'),
              vHas: 'sys:new:setting:log:voiceDetect',
            },
            {
              path: 'Faceprint',
              label: this.$t('FaceRecognitionrecord'),
              vHas: 'sys:new:setting:log:faceDetect',
            },

            //模式切换记录
            {
              path: 'ModeSwitching',
              label: this.$t('modeSwitchingRecord'),
              vHas: 'sys:new:setting:log:mode',
            },
          ],
        },
        {
          key: 'OtherSetting',
          label: this.$t('ApplySettings'),
          vHas: 'sys:new:setting:application',
          vHasParent: 'sys:new:setting',
          navs: [
            {
              label: this.$t('Electronicfence'),
              path: 'fence',
              vHas: 'sys:new:setting:application:geofence',
            },
            {
              label: this.$t('FaceRecognition'),
              path: 'face',
              vHas: 'sys:new:setting:application:face',
            },
            {
              label: this.$t('VoiceprintRecognition'),
              path: 'voice',
              vHas: 'sys:new:setting:application:voice',
            },
          ],
          brothers: {
            label: this.$t('deviceManagement'),
            key: 'deviceList',
            vHas: 'sys:new:setting:device',
            navs: [
              {
                label: this.$t('EquipmentList'),
                path: 'deviceList',
                vHas: 'sys:new:setting:device:list',
              },
              {
                label: this.$t('ParameterConfiguration'),
                path: 'sysProperty',
                vHas: 'sys:new:setting:device:config',
              },
              {
                label: this.$t('CommunicationConfiguration'),
                path: 'message',
                vHas: 'sys:new:setting:device:ouSetting',
              },
              {
                label: this.$t('IH5Setting'),
                path: 'tenantSet',
                vHas: 'sys:new',
                IsHas: this.checkFeatureCode('', true, false) && inlcudeDeviceSpecType(0),
              },
              {
                label: this.$t('categoryType'),
                path: 'CategoryConfig',
                vHas: 'sys:new:setting:device:mediaType',
              },
            ],
          },
        },
        {
          key: 'SysManage',
          label: this.$t('systemManagement'),
          vHas: 'sys:new:setting:system',
          navs: [
            {
              label: this.$t('userManagement'),
              path: 'userManage',
              vHas: 'sys:new:setting:system:user',
            },
            {
              label: this.$t('RoleManagement'),
              path: 'rolesManage',
              vHas: 'sys:new:setting:system:role',
            },
            {
              label: this.$t('ConfigureRouter'),
              path: 'wifi',
              vHas: 'sys:new:setting:system:wifi',
            },
            {
              label: this.$t('AppManagement'),
              path: 'appUpgrade',
              vHas: 'sys:new:setting:system',
              IsHas:
                (this.checkFeatureCode('', false, true) || this.checkFeatureCode('', true, false)) &&
                inlcudeDeviceSpecType(1, 2, 3),
            },
            {
              label: this.$t('aPIKeyManagement'),
              path: 'secretManage',
              vHas: 'sys:new',
              IsHas: this.checkFeatureCode('', true, false),
            },
            {
              label: this.$t('Q&ASystemManage'),
              path: 'qaManage',
              vHas: 'sys:new:setting:system',
              IsHas: this.checkFeatureCode('', false, true) && inlcudeDeviceSpecType(1, 2),
            },
            {
              label: this.$t('integratSystemManage'),
              path: 'systemManage',
              vHas: 'sys:new:setting:system:user',
              IsHas: this.checkFeatureCode('', true, false),
            },
            {
              label: this.$t('AIAnalysisManage'),
              path: 'aiAnalysisManage',
              vHas: 'sys:new:setting:system:ai',
            },
          ],
        },
        {
          key: 'PersonalMessage',
          label: this.$t('personalInformation'),
          vHas: 'sys:new',
          navs: [
            {
              label: this.$t('PersonalSettings'),
              path: 'personal',
              vHas: 'sys:new',
              IsHas: true,
            },
          ],
        },
      ],
      //头部菜单显示
      headerOffset: {
        set: 0,
        command: 0,
        focus: 0,
        monitor: 0,
        comunicate: 0,
        warn: 0,
        person: 0,
        device: 0,
        //设置菜单大小
        setMenuSize: 500,
      },
      leftMenu: [],
      rightMenu: [],
      // 现场管理
      personMune: [
        {
          label: this.$t('personnelManagementOverview'),
          path: 'Index',
          vHas: 'sys:new:person',
        },
        {
          label: this.$t('personnelActivityStatistics'),
          path: 'ActivityStatistics',
          vHas: 'sys:new:person:activityStatistics',
        },
        {
          label: this.$t('personnelDataStatistics'),
          path: 'DataStatistics',
          vHas: 'sys:new:person:dataStatistics',
        },
        {
          label: this.$t('fenceEntryExitStatistics'),
          path: 'EntryExitStatistics',
          vHas: 'sys:new:person:entryExitStatistics',
        },
      ],
      // 数据中心
      dataMune: [
        {
          label: this.$t('mediaData'),
          path: 'mediaData',
          vHas: 'sys:new:data',
        },
        {
          label: this.$t('deviceData'),
          path: 'deviceData',
          vHas: 'sys:new:data:device',
        },
      ],
      // 系统菜单
      systemData: [],
      allMunes: [],
      deviceMune: [
        {
          label: this.$t('IntelligentDevice'),
          path: 'newMonitor',
          vHas: 'sys:new:monitor',
        },
        {
          label: this.$t('controlEquipment'),
          path: 'controlCabinet',
          vHas: 'sys:new:monitor:cabinet',
        },
        {
          label: this.$t('AIAnalysis'),
          path: 'aiAnalysis',
          vHas: 'sys:new:monitor:ai',
        },
      ],
    }
  },
  methods: {
    getAddList() {
      this.systemData = []
      let param = {
        systemStatus: 1,
        sortColName: 'systemSort',
        useAsc: 1,
      }
      systemList(param).then(res => {
        if (res.state === 0) {
          res.data.map(item => {
            this.systemData.push({
              label: item.systemName,
              path: item.systemUrl,
              vHas: 'sys:new:setting',
              value: item.accessType,
            })
          })
        }
      })
      //样式修改
      setTimeout(() => {
        this.setMeunStyleByHas()
      }, 500)
    },
    // onSwitchLanguage(e) {
    //   this.viewFont = !this.viewFont
    //   localStorage.setItem('lang', e)
    //   this.$i18n.locale = e
    //   // 切换地图类型
    //   switchMapType()
    //   // 部分资源需要刷新
    //   setTimeout(() => {
    //     window.location.reload()
    //   }, 0)
    // },
    onSwitchLanguage(lang) {
      this.viewFont = lang.value
      localStorage.setItem('lang', lang.lang)
      this.$i18n.locale = lang.lang
      // 切换地图类型
      switchMapType()
      // 部分资源需要刷新
      setTimeout(() => {
        window.location.reload()
      }, 0)
    },
    // 响应切换主题
    handleSwitchTheme(data) {
      this.$store.commit('switchTheme', data)
      themes(data)
      let param = {
        platformStyle: data === 'dark' ? 1 : 0,
      }
      updateUserInfo(param).then(res => {
        console.log(res)
      })
    },
    // 查询租户自定义系统名称、图标等
    tenantSysConfig() {
      if (getSession('tenantId') === '251912054784307200') {
        this.systemName = '吉林坤腾科技北斗定位监测调度管理平台'
        return
      } else {
        this.systemName = this.$t('现场作业智能管控平台')
      }
      tenantSysConfig().then(res => {
        if (res.state === 0) {
          if (res.data) {
            for (let item of res.data) {
              if (item.key === 'CUSTOM_SYS_NAME' && item.value) {
                this.systemName = item.value
                if(localStorage.getItem('lang') !== 'en') {
                  if (this.systemName.length > 23) {
                    this.systemName = this.systemName.substring(0, 23)
                  }
                }
              }
            }
          }
        }
      })
      if(localStorage.getItem('lang') !== 'en') {
        if (this.systemName.length > 23) {
          this.systemName = this.systemName.substring(0, 23)
        }
      }
    },
    // 点击查看语音
    toConver() {
      this.$router.push({ name: 'comunicate', query: { type: 'conversation' } })
      this.$store.commit('currentIndex', 'comunicate')
      this.$store.commit('showTip', false)
    },
    closeTip() {
      // 关闭语音提示
      this.visible = false
      this.$store.commit('showTip', false)
    },
    /**
     * 检查菜单权限
     */
    checkFeatureCode(code, isAdmin, adminAccount) {
      if (isAdmin) {
        // 从浏览器缓存中获取是否为超级管理用户
        let loginIsAdmin = sessionStorage.getItem('isAdmin')
        if (loginIsAdmin === '1') {
          return true
        }
        return false
      }
      if (adminAccount) {
        // 校验用户账号是否为admin
        let loginAccount = sessionStorage.getItem('account')
        if (loginAccount === 'admin') {
          return true
        }
        return false
      }
      let isExist = false
      // 从浏览器缓存中获取权限数组（该数组在登入成功后拉取用户的权限信息时保存在浏览器的缓存中）
      let featureCode = sessionStorage.getItem('featureCode')
      if (!featureCode) {
        return false
      }
      if (featureCode.indexOf(code) >= 0) {
        // 若在按钮中定义的权限字段能在后端返回的权限数组中能找到，则该按钮可显示
        isExist = true
      }
      return isExist
    },
    // 点击菜单
    handleRouter(path, type, item) {
      let isSystem = item ? item.value + '' : null
      this.currentIndex = type
      this.currentPath = path
      if (!isSystem) {
        let resPath = null
        if (type === 'dataCenter' || type === 'monitor') {
          resPath = '/newIndex/' + path
        } else if (type === 'person') {
          resPath = '/newIndex/new-person/' + path
        }
        this.$router.push({ path: resPath })
      } else {
        if (item.value === 1) {
          // 新页签打开
          window.open(item.path)
        } else {
          this.$store.commit('changeSystem', item.path)
          this.$router.push({ path: '/newIndex/systems' })
        }
      }
    },
    clickEnter(type, item) {
      this.$store.commit('currentIndex', type)
      this.currentPath = ''
      switch (type) {
        case 'device':
          this.currentIndex = 'device'
          this.$router.push({ path: '/newIndex/newDevice' })
          break
        case 'person':
          this.currentIndex = 'person'
          this.currentPath = 'Index'
          this.$router.push({ path: '/newIndex/new-person/Index' })
          break
        case 'monitor':
          this.currentIndex = 'monitor'
          this.$router.push({ path: '/newIndex/newMonitor' })
          break
        case 'command':
          this.currentIndex = 'command'
          this.$router.push({ path: '/newIndex/newCommand' })
          break
        case 'focus':
          this.currentIndex = 'focus'
          this.$router.push({ path: '/newIndex/newFocus' })
          break
        case 'comunicate':
          this.currentIndex = 'comunicate'
          this.$router.push({ path: '/newIndex/newComunicate' })
          break
        case 'warn':
          this.currentIndex = 'warn'
          this.$router.push({ path: '/newIndex/newWarn' })
          break
        case 'set':
          this.currentIndex = 'set'
          this.currentPath = 'personal'
          this.$router.push({ path: '/newIndex/newSet/personal' })
          break
        case 'home':
          this.currentIndex = 'home'
          this.$router.push({ path: '/newIndex/newHome' })
          break
        case 'images':
          this.currentIndex = 'images'
          this.$router.push({ path: '/newIndex/imageRetrieval' })
          break
        case 'dataCenter':
          this.currentIndex = 'dataCenter'
          this.currentPath = 'mediaData'
          if (this.dataMune.length === 1 && this.dataMune[0].vHas === 'sys:new:data:device') {
            this.$router.push({ path: '/newIndex/deviceData' })
          } else {
            this.$router.push({ path: '/newIndex/mediaData' })
          }
          break
        case 'system':
          if (item && item.value === 1) {
            // 新页签打开
            window.open(item.path)
          } else {
            this.$store.commit('changeSystem', item.path)
            this.currentIndex = 'system'
            this.$router.push({ path: '/newIndex/systems' })
          }
          break
        default:
          break
      }
    },
    handleEnter(path) {
      this.currentIndex = 'set'
      if (!path) {
        return
      }
      if (path === 'logout') {
        this.layout()
        return
      }
      if (path === 'dmp') {
        this.toDmp()
        return
      }
      if (path === 'Monitor') {
        this.$router.push({ path: '/Monitor' })
        return
      }
      this.currentPath = path
      let resPath = '/newIndex/newSet/' + path
      this.$router.push({ path: resPath })
    },
    /**
     * 跳转数字化平台
     */
    toDmp() {
      location.href = '/dmp/'
    },
    /**
     * 退出登录，清除登录数据
     */
    layout() {
      // 流媒体与ws资源销毁
      closeRTC()
      //delSession('access_token')
      delSession('expireTime')
      delSession('HWSecurity_access_token')
      delSession('userId')
      sessionStorage.removeItem('featureCode')
      sessionStorage.removeItem('isAdmin')
      this.$store.commit('handleshowHelmetTable', false)
      this.$store.commit('updatePlayTrail', false)
      this.$store.commit('showTip', false)
      // 控制退出重登间隔，确保资源完成销毁
      const loading = this.$loading({
        lock: true,
        text: this.$t('signOuting'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        delSession('access_token')
        this.$message({
          type: 'success',
          message: this.$t('exitSuccessful'),
          duration: 1000,
        })
        this.$router.push({ path: '/Login' })
        loading.close();
      }, 1500);
    },
    //根据权限修改菜单样式
    setMeunStyleByHas() {
      let menuTrueList = []
      let powerList = [
        // 图像检索 nenuHasName菜单权限未完成
        { name: this.$t('DataCenter'), nameCode: 'dataCenter', nenuHasName: 'sys:new:data', menus: this.dataMune },
        {
          name: this.$t('PersonnelManagement'),
          nameCode: 'person',
          nenuHasName: 'sys:new:person',
          menus: this.personMune,
        },
        {
          name: this.$t('monitoringCenter'),
          nameCode: 'monitor',
          nenuHasName: 'sys:new:monitor',
          menus: this.deviceMune,
        },
        { name: this.$t('PreciseScheduling'), nameCode: 'command', nenuHasName: 'sys:new:command' },
        { name: this.$t('Focus'), nameCode: 'focus', nenuHasName: 'sys:new:focus' },
        { name: this.$t('imageRetrieval'), nameCode: 'images', nenuHasName: 'analyse:media:formal' },
        { name: this.$t('IntercomCenter'), nameCode: 'comunicate', nenuHasName: 'sys:new:comunicate' },
        { name: this.$t('AlarmCenter'), nameCode: 'warn', nenuHasName: 'sys:new:warn' },
      ]
      // 设置只有设备列表权限时 “数据中心” -> “设备管理”
      if (!searchMenuCode('sys:new:data,') && searchMenuCode('sys:new:data:device')) {
        var newMenus = []
        newMenus.push(this.dataMune[1])
        this.dataMune = newMenus
        var newDataCenter = { name: this.$t('deviceManagement'), nameCode: 'dataCenter', nenuHasName: newMenus[0].vHas}
        powerList[0] = newDataCenter
      }
      // 循环已有权限菜单
      for (var menuItem of powerList) {
        if (searchMenuCode(menuItem.nenuHasName)) {
          if (menuItem.nameCode === 'images' && inlcudeDeviceSpecType(1, 2, 3)) {
            menuTrueList.push({
              nameCode: menuItem.nameCode,
              name: menuItem.name,
              menus: menuItem.menus,
            })
          }
          if (menuItem.nameCode !== 'images') {
            menuTrueList.push({
              nameCode: menuItem.nameCode,
              name: menuItem.name,
              menus: menuItem.menus,
            })
          }
        }
      }
      if (this.systemData.length === 1) {
        let oneData = this.systemData[0]
        menuTrueList.push({
          nameCode: 'system',
          value: oneData.value,
          name: oneData.label,
          path: oneData.path,
          menus: '',
        })
      } else if (this.systemData.length !== 0 && this.systemData.length > 1) {
        let moreData = this.systemData[0]
        menuTrueList.push({
          nameCode: 'system',
          name: moreData.label,
          value: moreData.value,
          path: moreData.path,
          menus: this.systemData,
        })
      }

      this.allMunes = menuTrueList
      // 对半分菜单
      let half = Math.ceil(menuTrueList.length / 2)
      this.leftMenu = menuTrueList.splice(0, half)
      this.rightMenu = menuTrueList.splice(-half)

      // //设置菜单大小设定
      let numMenu = 1
      numMenu += searchMenuCode('sys:new:setting:log') ? 1 : 0
      numMenu += searchMenuCode('sys:new:setting:application') || searchMenuCode('sys:new:setting:device') ? 1 : 0
      numMenu += searchMenuCode('sys:new:setting:system') ? 1 : 0

      let size = 500
      if (localStorage.getItem('lang') === 'en') {
        size = 820
      }
      this.headerOffset.setMenuSize = (numMenu * size) / 4
      //设置菜单-子菜单验证
      for (let k in this.menuList) {
        if (this.menuList[k].brothers !== undefined) {
          if (!searchMenuCode(this.menuList[k].vHas) && !searchMenuCode(this.menuList[k].brothers.vHas)) {
            this.menuList[k].vHasParent = 'false'
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
    defaultActive: function() {
      return '/' + this.$route.path.split('/')[1]
    },
    currentStoreIndex() {
      return this.$store.state.currentIndex
    },
    showTip() {
      if (this.currentIndex !== 'comunicate') {
        return this.$store.state.showTip
      } else {
        this.$store.commit('showTip', false)
        return false
      }
    },
    setShowbyIcon() {
      return this.rightMenu.length > 4 || (this.leftMenu.length < 5 && this.rightMenu.length === 4)
    },
  },
  watch: {
    currentStoreIndex: {
      handler(val) {
        this.currentIndex = val
      },
      deep: true,
    },
    // 监听路由变化
    $route: {
      handler: function(val, oldVal) {
        if (val.name === 'Caution') {
          if (this.$route.query.currentPath) {
            this.currentPath = 'caution'
          }
        } else if (val.name === 'dataCenter' && val.path === '/newIndex/mediaData') {
          this.currentPath = 'mediaData'
        }
        this.$store.commit('updatePlayTrail', false)
        this.$store.commit('handleshowHelmetTable', false)
      },
      deep: true,
    },
  },
  created() {
    // 浅色
    if (this.isDefaultTheme) {
      themes('default')
    } else {
      themes('dark')
    }
    this.getAddList()
    let currentPage = this.$router.currentRoute || null
    this.currentIndex = currentPage ? currentPage.name : ''
    let currentUrl = window.location.href
    let splitArr = currentUrl.split('/')
    this.currentPath = splitArr[splitArr.length - 1]
    if (currentUrl.includes('newSet')) {
      this.currentIndex = 'set'
    } else if (currentUrl.includes('new-person')) {
      this.currentIndex = 'person'
    }
    if (localStorage.getItem('lang') === 'zh') {
      this.viewFont = 0
    } else if (localStorage.getItem('lang') === 'hk' || localStorage.getItem('lang') === 'tw') {
      this.viewFont = 1
    } else if (localStorage.getItem('lang') === 'en') {
      this.viewFont = 2
    }
    this.tenantSysConfig()
    // this.viewFont = localStorage.getItem('lang') === 'hk' || localStorage.getItem('lang') === 'tw' ? false : true
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/header.styl'
</style>
